const variants = {
  primary: 'bg-ink text-white hover:bg-black',
  ghost:   'bg-white text-ink border border-line hover:bg-line/40',
  danger:  'bg-terra-500 text-white hover:bg-terra-600',
}
const sizes = {
  sm: 'px-3 py-2 text-[13px] sm:py-1.5 sm:text-[12.5px]',
  md: 'px-4 py-2.5 text-[14px] sm:py-2 sm:text-[13px]',
  lg: 'px-5 py-3 text-[14px]',
}

export default function Button({
  variant = 'primary', size = 'md', className = '', children, ...rest
}) {
  return (
    <button
      className={`inline-flex items-center gap-2 rounded-lg font-medium transition-colors disabled:cursor-not-allowed disabled:opacity-50 ${variants[variant]} ${sizes[size]} ${className}`}
      {...rest}
    >
      {children}
    </button>
  )
}
